import { DataGrid, esES } from "@mui/x-data-grid";
import { useState } from "react";

const Table = ({
  paginationMode = "client",
  paginationModel = { page: 1, pageSize: 100, },
  onPaginationModelChange,
  rowCount,
  renderButtonFooter,


  bgHeader,
  columnHeaderHeight = 56,
  minHeightFooter = "52px",
  colorHeader,
  density = "compact",
  data,
  rowClick,
  onCellClick,
  loading,
  render,
  getRowClassName,
  search,
  maxHeight = "50vh",
  height = 600,
  msAutoSerach = true,
  excel,
  filterBar,
  onSelectionModelChange,
  className = null,
  sx,
}) => {
  const { rows, columns } = data;
  const [state, setState] = useState("");

  const changeValue = ({ target: { value } }) => setState(value);

  const arrayValue = state.toLowerCase().trim().split(" ");

  const newFilter = (arrayValue, data) => {
    arrayValue = arrayValue.filter((elemento) => elemento !== "");

    while (arrayValue?.length) {
      data = data.filter((el) => fiterByProperty(el, arrayValue));
      arrayValue.splice(0, 1);
    }

    return data;
  };

  

  const fiterByProperty = (el, a) => {
    for (const key in el) {
      if (el.hasOwnProperty(key) && el[key]) {
        const attribute = el[key].toString().toLowerCase();
        if (attribute.includes(a[0])) return true;
      }
    }
    return false;
  };

  return (
    <>
      {(search || render) && (
        <div className="card mb-1 d-flex flex-row">
          {(search || render) && (
            <div className="card mb-1 d-flex flex-row">
              {render && render()}
              {search && (
                <div className={`d-flex flex-row p-2 ${msAutoSerach && "ms-auto"}`}>
                  <input
                    id="search"
                    type="search"
                    className="form-control"
                    value={state}
                    placeholder="Buscar..."
                    onChange={changeValue}
                  />
                </div>
              )}
            </div>
          )}
        </div>
      )}

      <div style={{ maxHeight, height, width: "100%" }} className="d-flex position-relative ">
        {excel && (
          <div className="position-absolute z-3" style={{ bottom: "10px", left: "10px" }}>
            {excel()}
          </div>
        )}
        {renderButtonFooter && (
          <div className="position-absolute z-3" style={{ bottom: "10px", left: "10px" }}>
            {renderButtonFooter()}
          </div>
        )}
        <DataGrid
          className={className}
          //? PARA PAGINACION CON BACK
          pagination
          paginationMode={paginationMode}
          paginationModel={paginationModel}
          onPaginationModelChange={onPaginationModelChange ?? null}
          rowCount={rowCount ?? null}

          columnHeaderHeight={columnHeaderHeight}
          onRowClick={rowClick ? rowClick : () => { }}
          rows={newFilter(arrayValue, rows)}
          columns={columns}
          pageSize={20}
          loading={loading}
          disableSelectionOnClick
          columnVisibilityModel={{ id: false, }}
          onCellClick={onCellClick ? onCellClick : () => { }}
          // density={"pepe"}
          // density={density}
          hideFooterSelectedRowCount
          localeText={esES.components.MuiDataGrid.defaultProps.localeText}
          sx={{
            // disable cell selection style
            ".MuiDataGrid-cell:focus": {
              outline: "none",
            },
            /*             "& .MuiDataGrid-row:focus": {
                          background: "black",
                        }, */
            // pointer cursor on ALL rows
            "& .MuiDataGrid-row:hover": {
              cursor: "pointer",
              background: "none",
            },

            "& .MuiDataGrid-row.oddRow": {
              background: "#f2f2f2",
            },
            // '& .MuiDataGrid-columnHeaders': {
            //   height: "150px", //^ Cambia la altura del encabezado
            // },
            '& .MuiDataGrid-columnHeader': {
              backgroundColor: bgHeader ?? null,
              color: colorHeader ?? null,
              lineHeight: 'normal !important', //^ Ajusta la altura del contenido
              // padding: '20px 10px !important', //^ Espaciado interno
              // margin: '10px 0 !important', //^ Espaciado interno

            },
            "& .MuiDataGrid-columnHeaderTitle": {
              color: colorHeader ?? "#111", // <--- esta clase es la que realmente pinta el texto del header
            },
            // '& .MuiDataGrid-virtualScroller': {
            //   minHeight: "100%",
            //   height: '75%',
            //   maxHeight: 'calc(100% - 150px)',
            // },
            '& .MuiDataGrid-footerContainer': {
              minHeight: minHeightFooter,
            },
            ".MuiDataGrid-cell:focus, .MuiDataGrid-columnHeader:focus": {
              outline: "none",
            },
            ".MuiDataGrid-cell:focus-within, .MuiDataGrid-columnHeader:focus-within": {
              outline: "none",
            },


            ...sx,

          }}
          keepNonExistentRowsSelected
          checkboxSelection={onSelectionModelChange ? true : false}
          onSelectionModelChange={onSelectionModelChange ? onSelectionModelChange : () => { }}
          getRowClassName={getRowClassName ? getRowClassName : () => { }}
          disableColumnMenu
        />
      </div>
    </>
  );
};

export default Table;
